/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BpAddress } from '../../models/bp-address';

export interface FindCpBpAddress$Params {
  customerAccountId: number;
  addressId: number;
}

export function findCpBpAddress(http: HttpClient, rootUrl: string, params: FindCpBpAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<BpAddress>> {
  const rb = new RequestBuilder(rootUrl, findCpBpAddress.PATH, 'get');
  if (params) {
    rb.path('customerAccountId', params.customerAccountId, {});
    rb.path('addressId', params.addressId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BpAddress>;
    })
  );
}

findCpBpAddress.PATH = '/business-parties/cp/addresses/{customerAccountId}/{addressId}';
